export default __webpack_public_path__ + "static/media/info.9ce121a8.md";